import jobTemplates from './jobTemplates.json';

class TemplateService {
  // Get template based on position title
  static getTemplate(positionTitle) {
    if (!positionTitle || positionTitle.trim() === '') {
      return null;
    }
    
    const lowerTitle = positionTitle.toLowerCase().trim();
    
    // First, try exact match
    for (const category in jobTemplates) {
      if (category === 'default') continue;
      
      const templates = jobTemplates[category];
      for (const key in templates) {
        if (lowerTitle === key) {
          console.log(`✅ Exact match found: ${key}`);
          return templates[key];
        }
      }
    }
    
    // Second, try partial match (contains keywords)
    const keywords = lowerTitle.split(' ');
    
    for (const category in jobTemplates) {
      if (category === 'default') continue;
      
      const templates = jobTemplates[category];
      for (const key in templates) {
        // Check if any keyword matches the template key
        for (const keyword of keywords) {
          if (key.includes(keyword) || keyword.includes(key)) {
            console.log(`🔄 Partial match found: ${key} for "${positionTitle}"`);
            return templates[key];
          }
        }
      }
    }
    
    // Third, try category match
    for (const category in jobTemplates) {
      if (category === 'default') continue;
      
      for (const keyword of keywords) {
        if (category.includes(keyword) || keyword.includes(category)) {
          console.log(`📁 Category match found: ${category} for "${positionTitle}"`);
          const templates = jobTemplates[category];
          // Return first template from matching category
          const firstKey = Object.keys(templates)[0];
          if (firstKey) {
            return templates[firstKey];
          }
        }
      }
    }
    
    // No match found, return default
    console.log(`⚠️ No template found for "${positionTitle}", using default`);
    return jobTemplates.default;
  }
  
  // Get all available templates for dropdown (optional)
  static getAllTemplates() {
    const allTemplates = [];
    for (const category in jobTemplates) {
      if (category === 'default') continue;
      
      const templates = jobTemplates[category];
      for (const key in templates) {
        allTemplates.push({
          title: key,
          category: category,
          description: templates[key].description.substring(0, 100) + '...',
          skillsCount: templates[key].skills.length
        });
      }
    }
    return allTemplates;
  }
  
  // Search templates (optional)
  static searchTemplates(searchTerm) {
    if (!searchTerm) return [];
    
    const lowerSearch = searchTerm.toLowerCase();
    const results = [];
    
    for (const category in jobTemplates) {
      if (category === 'default') continue;
      
      const templates = jobTemplates[category];
      for (const key in templates) {
        if (key.includes(lowerSearch)) {
          results.push({
            title: key,
            category: category,
            template: templates[key]
          });
        }
      }
    }
    
    return results;
  }
}

export default TemplateService;